export enum ReportCategory {
	ONLINEORDER = "onlineOrder",
	SALES = "sales",
	ITEMS = "items",
	LABOR = "labor",
	SYSTEM = "system",
}
